<div mat-dialog-title class="ds">
  <span>{{ dialogTitle }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div id="formContainer" mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile, 'desktop': !isMobile}">
  <form (keyup.enter)="searchText()">
    <div id="searchFormContent" class="search-form-content">
      @if (!isOnAccountsPage) {
        <div id="accountManagerSearchForm">
          <ds-autocomplete id="accountManagerField" class="fill-width" (selectionChange)="selectedAccountManager($event)" [options]="mobileAMList"
            [label]="appStrings.quoteDetails_AccountManager" label_orientation="horizontal-label" [control]="newSearchForm.controls.accountManager"
          ></ds-autocomplete>
        </div>
      }
      @if (!isOnAccountsPage) {
        <div id="customerNameSearchForm">
          <ds-textfield id="customerNameField" class="fill-width" [label]="appStrings.quoteSearch_customerName" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.customerName"
          ></ds-textfield>
        </div>
      }
      @if (!isOnAccountsPage && !isLnOrderTab) {
        <div id="bpNumberSearchForm">
          <ds-textfield id="bpNumberField" class="fill-width" [label]="appStrings.quoteSearch_bpNumber" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.bpNumber" placeholder="Ex. 0123456789"
          ></ds-textfield>
        </div>
      }
      @if (!isInvoiceTab && !isLnOrderTab) {
        <div id="contactSearchForm">
          <ds-textfield id="contactField" class="fill-width" [label]="appStrings.quoteSearch_contact" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.contact"
          ></ds-textfield>
        </div>
      }
      @if (!isLnOrderTab) {
        <div id="partNumberSearchForm">
          <ds-textfield id="partNumberField" class="fill-width" [label]="appStrings.quoteSearch_partNumber" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.partNumber"
          ></ds-textfield>
        </div>
      }
      @if (isInvoiceTab) {
        <div id="invoiceNumberSearchForm">
          <ds-textfield id="invoiceNumberField" class="fill-width" [label]="appStrings.quoteSearch_invoiceNumber" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.invoiceNumber"
          ></ds-textfield>
        </div>
      }
      @if (!isInvoiceTab && !isLnOrderTab) {
        <div id="quoteNameSearchForm">
          <ds-textfield id="quoteNameField" class="fill-width" [label]="appStrings.quoteSearch_quoteName" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.quoteName"
          ></ds-textfield>
        </div>
      }
      @if (!isInvoiceTab) {
        <div id="quoteNumberSearchForm">
          <ds-textfield id="quoteNumberField" class="fill-width" [label]="activeTab === storageValues.OrderKey ? appStrings.quoteSearch_orderNumber : appStrings.quoteSearch_quoteNumber"
            label_orientation="horizontal-label" [control]="newSearchForm.controls.quoteNumber" placeholder="Ex. IMP-000011111"
          ></ds-textfield>
        </div>
      }
      @if (isLnOrderTab) {
        <div id="orderNumberSearchForm">
          <ds-textfield id="orderNumberField" class="fill-width" [label]="appStrings.quoteSearch_orderNumber" label_orientation="horizontal-label"
            [control]="newSearchForm.controls.orderNumber"
          ></ds-textfield>
        </div>
      }
      <div id="dollarAmountSearchForm">
        <ds-textfield id="dollarAmountField" class="fill-width" [label]="displayedTextAmount" label_orientation="horizontal-label"
          [control]="newSearchForm.controls.dollarAmount" [start_adornment_type]="displayCurrency ? 'text' : null"
          [start_adornment_value_text]="currencySymbol"
        ></ds-textfield>
      </div>
      <div id="poNumberSearchForm">
        <ds-textfield id="poNumberField" class="fill-width" [label]="appStrings.quoteSearch_poNumber" label_orientation="horizontal-label"
          [control]="newSearchForm.controls.poNumber"
        ></ds-textfield>
      </div>
      @if (lnStatuses?.length) {
        <div id="lnOrderStatusSearchForm">
          <ds-select id="lnOrderStatusField" class="fill-width" [label]="appStrings.label_lnOrderStatus" [dropOptions]="lnStatuses"
            label_orientation="horizontal-label" [control]="newSearchForm.controls.lnOrderStatus"
          ></ds-select>
        </div>
      }
      @if (showForOptions?.length) {
        <div id="showForSearchForm">
          <ds-select id="showForField" class="fill-width" [label]="appStrings.quotes_showFor" [dropOptions]="showForOptions"
            label_orientation="horizontal-label" [control]="newSearchForm.controls.quotesShowFor"
          ></ds-select>
        </div>
      }
      <div id="startDateSearchForm">
        <ds-date-picker id="startDateField" class="fill-width" [label]="appStrings.quotesStartDate"
          label_orientation="horizontal-label" [control]="newSearchForm.controls.startDate"
          [date_format]="dsDateFormat"
        ></ds-date-picker>
      </div>
      <div id="endDateSearchForm">
        <ds-date-picker id="endDateField" class="fill-width" [label]="appStrings.quotesEndDate"
          label_orientation="horizontal-label" [control]="newSearchForm.controls.endDate"
          [date_format]="dsDateFormat"
        ></ds-date-picker>
      </div>
    </div>
  </form>
</div>

<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeButton" variant="label-only" size="medium" type="tertiary" (onClick)="closeDialog()"
      [label]="appStrings.button_close">
    </ds-button>
    <ds-button id="clearFiltersButton" variant="label-only" size="medium" type="secondary" (onClick)="clearAllFilters()"
      [label]="appStrings.accounts_clearFilters" [isDisabled]="!formHasValueForClear">
    </ds-button>
    <ds-button id="searchButton" variant="label-only" size="medium" type="primary" (onClick)="searchText()"
      [label]="appStrings.accounts_search" [isDisabled]="!formHasValue">
    </ds-button>
  </div>
</div>